var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('img',{attrs:{"src":require("../assets/img/gift.png"),"alt":""},on:{"click":_vm.goluckywheel}}),_c('img',{attrs:{"src":require("../assets/img/light.png"),"alt":""}}),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }